
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index5cytbDzWKVdyUhCO8ACIIa_oSguwjKfzRQ2KzfDeFPcMeta } from "/opt/cargolink/app/cargolink-app/pages/index.vue?macro=true";
import { default as termsjEr5MTbjXIcZikQALClv4U8nUCDII5t0HXVsI80nMyMMeta } from "/opt/cargolink/app/cargolink-app/pages/terms.vue?macro=true";
import { default as privacywi78Escm28DKWj0Xt53cgHsocl3jOfBt8lvIoxbQS84Meta } from "/opt/cargolink/app/cargolink-app/pages/privacy.vue?macro=true";
import { default as loginFshIbLiG6FKvO5F_45UPAwJ91b0hlwBW_45cVA_H8976DwYMeta } from "/opt/cargolink/app/cargolink-app/pages/auth/login.vue?macro=true";
import { default as indexL5_45eQV0QAhQnNFpsxUJxCiRHEwwhhMjBpJs36jPFwxoMeta } from "/opt/cargolink/app/cargolink-app/pages/admin/index.vue?macro=true";
import { default as indexynYCVMw6_DOneTi0gecbbPdUUejxrydfetVL3c0KohEMeta } from "/opt/cargolink/app/cargolink-app/pages/mover/index.vue?macro=true";
import { default as indexpuOiu1ISDkI_5gqT29x_45IYWxMabWb1gkyNwOLuDQOagMeta } from "/opt/cargolink/app/cargolink-app/pages/driver/index.vue?macro=true";
import { default as unauthorizedtVdVpozK6qKn7Jme4ZkSHWE7ToKi6c_TevEzR3LDLd8Meta } from "/opt/cargolink/app/cargolink-app/pages/unauthorized.vue?macro=true";
import { default as registerR4HzjFq5D3_kQ5io6_45pIbPZqxWyDTyZTMrc_DGQFA0UMeta } from "/opt/cargolink/app/cargolink-app/pages/auth/register.vue?macro=true";
import { default as indexzFvJ6HZuw4NM_45MsvqLTva9AHLG_e7Lf6tnGI0Sg_45WpUMeta } from "/opt/cargolink/app/cargolink-app/pages/carrier/index.vue?macro=true";
import { default as indexT6aRCxMrOg22ui0UZCVZC7ZI1iOkbJGoa6DzEDSyMawMeta } from "/opt/cargolink/app/cargolink-app/pages/profile/index.vue?macro=true";
import { default as indexPIjYSIHingn2nQ5_45ufojslV8o1iMHnwawhh60ZETbnwMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/index.vue?macro=true";
import { default as supportAfc57tOm2EkQATDYW9xlyQW_GbGQqTTRetHA1kqCIl8Meta } from "/opt/cargolink/app/cargolink-app/pages/driver/support.vue?macro=true";
import { default as vehicleoAk6GvcW7nvh76ysiV99XgBaixGNHO9xLPMHbJJ9Up4Meta } from "/opt/cargolink/app/cargolink-app/pages/driver/vehicle.vue?macro=true";
import { default as index_CfDggHdel3LdXNCWbOa7_454baeMa_ZQ__gjoTyF9Y14Meta } from "/opt/cargolink/app/cargolink-app/pages/admin/sms/index.vue?macro=true";
import { default as paymentsDEdrkzwqlv2EjcrWocWY7hyjglHLPbKk1pfD7fup7LEMeta } from "/opt/cargolink/app/cargolink-app/pages/driver/payments.vue?macro=true";
import { default as indexzgEhSoaL91MTYQpeGsoZ1kfk4_45eSAGivKiLCjCh8Mr0Meta } from "/opt/cargolink/app/cargolink-app/pages/forwarder/index.vue?macro=true";
import { default as billingJTHKHuLF4ifB_45VgP44G_45jfav3ysJUh6CFBccyN5msK8Meta } from "/opt/cargolink/app/cargolink-app/pages/shipper/billing.vue?macro=true";
import { default as _91id_93GsypUA5UycWCvpm4LMgo7haJ76VMYdrASsi7tcsgmeMMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/support/tickets/[id].vue?macro=true";
import { default as _91id_932YlBzBbWbo5e7_a_4512euMdBXIomtFhW09ddW_IZdt78Meta } from "/opt/cargolink/app/cargolink-app/pages/shipper/support/disputes/[id].vue?macro=true";
import { default as index7_45EuReQGdO4szTjbBMy6vIqoOZCNw2vEj7dHkPDwojQMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/support/tickets/index.vue?macro=true";
import { default as indexmqgg4QoCeUzivnAxUwvFcM1mCvBMYj0zdye00Hlt_28Meta } from "/opt/cargolink/app/cargolink-app/pages/shipper/support/disputes/index.vue?macro=true";
import { default as supporthwgsOm9WmkNvshIcb8L_Jiy7El4u78m9aWzA4dT_uDMMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/support.vue?macro=true";
import { default as applyYJI8ivCWyatwPgnAnq4ndj_455pB4Ukon8Z_An8Yr4cx0Meta } from "/opt/cargolink/app/cargolink-app/pages/auth/mover/apply.vue?macro=true";
import { default as indexDAe3ryfasNvbZSBjQtX_45yl4qpzOVcOmIe_454hyuGPuxYMeta } from "/opt/cargolink/app/cargolink-app/pages/admin/users/index.vue?macro=true";
import { default as applyKGkMkPq8u4MTGt0BBTjugYNuL6zVrc3gLqoXoiNO2VYMeta } from "/opt/cargolink/app/cargolink-app/pages/auth/driver/apply.vue?macro=true";
import { default as indexKHJa7zGeHfMmc_45l_LDDaEkaDLCUg1LGkVzFXSZEWZxgMeta } from "/opt/cargolink/app/cargolink-app/pages/auth/verify/index.vue?macro=true";
import { default as account_45restrictedhx6DRqS_S6oETl54MFonB7Cs4XVldfhDRo0IUphh_45lcMeta } from "/opt/cargolink/app/cargolink-app/pages/account-restricted.vue?macro=true";
import { default as apply7iM7wlGJp_f_45ANGdlSe2HvlndA_453S3e1JBENSdFfxmYMeta } from "/opt/cargolink/app/cargolink-app/pages/auth/carrier/apply.vue?macro=true";
import { default as register_32copyj7DEyQYtiZ5fB9MXmsiW5hPOLkpvBVCOM50TlPmGCMcMeta } from "/opt/cargolink/app/cargolink-app/pages/auth/register copy.vue?macro=true";
import { default as indexUfRGJlRu0fOBV8RocEB5wdoMg_45pJSRTKuC3TdAypr44Meta } from "/opt/cargolink/app/cargolink-app/pages/mover/offers/index.vue?macro=true";
import { default as reset_45passwordo0d6XKNuheG33TWhhqxJARTDTct2MHKgFPElx70YTdwMeta } from "/opt/cargolink/app/cargolink-app/pages/auth/reset-password.vue?macro=true";
import { default as _91token_93mvwtojPa1CU1JXb1mi4QbKOflHzM7B8P_45USEt4uOYz4Meta } from "/opt/cargolink/app/cargolink-app/pages/auth/verify/[token].vue?macro=true";
import { default as indexiOfJaL1psTlxWrz__45yFVDqtKDgHTDB3wHxkdVIoFrZIMeta } from "/opt/cargolink/app/cargolink-app/pages/mover/history/index.vue?macro=true";
import { default as indexNVLJr8Yfps4rAeV_kpz_0X2s8hoabLdHBLZy_iRmDSYMeta } from "/opt/cargolink/app/cargolink-app/pages/notifications/index.vue?macro=true";
import { default as preferencesE9Y_cI0Q6gmRsGIQDrObjaLGjc4X9D2oV1Mm5qK3nNYMeta } from "/opt/cargolink/app/cargolink-app/pages/profile/preferences.vue?macro=true";
import { default as indexPPf2uFVWjgZPF1tvP9ioKCU2fudLyq9DQQu5bsHBJ2sMeta } from "/opt/cargolink/app/cargolink-app/pages/admin/disputes/index.vue?macro=true";
import { default as indexpoxD9kiaYragJYp42CWiM6NHZoLagpp8Am9f_Cmbp7gMeta } from "/opt/cargolink/app/cargolink-app/pages/admin/settings/index.vue?macro=true";
import { default as forgot_45passwordXeuVjnBdnRwQSI7LCZ8E8gQ8dWzToqmj3hJz5a8gXxgMeta } from "/opt/cargolink/app/cargolink-app/pages/auth/forgot-password.vue?macro=true";
import { default as applySOAEUm7mGI5NYjn1XLOtuJWlYoNPUTJPdCL3LIMqbPYMeta } from "/opt/cargolink/app/cargolink-app/pages/auth/forwarder/apply.vue?macro=true";
import { default as indexfprc1gHfkfifzoMa_S8ZPt53w10L70oq9bT3CYscuoEMeta } from "/opt/cargolink/app/cargolink-app/pages/mover/settings/index.vue?macro=true";
import { default as newA9PgBS9G1XsnfPLR4q5LjeXlG4VD9_8AJieMXeCB_45PsMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/shipping/new.vue?macro=true";
import { default as index9REPo3k3v_45VB4tqkzKX3rmVe8Pyb2OM9ntwfvyHZMroMeta } from "/opt/cargolink/app/cargolink-app/pages/admin/analytics/index.vue?macro=true";
import { default as indexm8YN0WzBcdRqgXLyZzPc_MqTNfDSUXgtmqWAGtNd6PUMeta } from "/opt/cargolink/app/cargolink-app/pages/admin/shipments/index.vue?macro=true";
import { default as indexzgdieaLAZITXq2WpgSt6FMtbjteeOatXdpR99JCdGdEMeta } from "/opt/cargolink/app/cargolink-app/pages/carrier/drivers/index.vue?macro=true";
import { default as indextCwtOkA_UpI6VfpeiSzUyfYamd9EUjCUqWNf_45rE8HyUMeta } from "/opt/cargolink/app/cargolink-app/pages/carrier/finance/index.vue?macro=true";
import { default as _91id_936pGRyEWOxiNecVyYbjSb89NHfsK7G8vvNMKDcAGkHQUMeta } from "/opt/cargolink/app/cargolink-app/pages/driver/intransit/[id].vue?macro=true";
import { default as indexjX3DFcTj6r0a3YnQzS_ryaHVXxdxRNPs29Sj5LMPDk0Meta } from "/opt/cargolink/app/cargolink-app/pages/driver/settings/index.vue?macro=true";
import { default as newMlv0xuUJ1wocrfAl0un30OMbFkBEfsySzwYL3pep7N0Meta } from "/opt/cargolink/app/cargolink-app/pages/shipper/intransit/new.vue?macro=true";
import { default as _91id_93Aq_ch2M1M_k45wX6R3yJRZvtdoW64kIfk_9mErhoMFcMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/messages/[id].vue?macro=true";
import { default as _91id_93zz1_455rlPfz9NC4I_29tkdiGM0gwF5yFU19rlAYYlqSIMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/shipping/[id].vue?macro=true";
import { default as indexvcTBy5s1BzAHNTlcT_458uS93UCdLa7KQgvCwThWsVmjMMeta } from "/opt/cargolink/app/cargolink-app/pages/admin/financials/index.vue?macro=true";
import { default as indexV7b56L9QuyujzReFy_p50k3C0OWAZivBbf_R4yRY9gIMeta } from "/opt/cargolink/app/cargolink-app/pages/admin/warehouses/index.vue?macro=true";
import { default as indexnBZke5gklti3JS2aaDTmKw3AY4oJL61SY5en5fpcNWEMeta } from "/opt/cargolink/app/cargolink-app/pages/carrier/settings/index.vue?macro=true";
import { default as indexHXsKXYmcKSVaf5NOFEqf6AWWvyfiI3fuCse2bUKzAtgMeta } from "/opt/cargolink/app/cargolink-app/pages/carrier/vehicles/index.vue?macro=true";
import { default as _91id_935TtB3Xo_454j6KoRNa9fkrqMGdqaTZ6NZfSP_45itwjhE6MMeta } from "/opt/cargolink/app/cargolink-app/pages/driver/cityxpress/trip/[id].vue?macro=true";
import { default as tripaWRKH_45L7GWClgnoR9mrLD2uZxMH_45X5liZyZKEXwKr0QMeta } from "/opt/cargolink/app/cargolink-app/pages/driver/cityxpress/trip.vue?macro=true";
import { default as indexpAh9p3IQdKFI5HGizEWvWt3dsL1CNYGWvVzmjLjay78Meta } from "/opt/cargolink/app/cargolink-app/pages/driver/intransit/index.vue?macro=true";
import { default as indexv8BdqrZLh3fytWD0do5SFdw3VyPle81MTVRgkpDTN1MMeta } from "/opt/cargolink/app/cargolink-app/pages/driver/shipments/index.vue?macro=true";
import { default as _91id_93ukg7XKkX9Ydw3s0Qf2IPwPR5qFfOqMSGL7Z7ZOvK_45qgMeta } from "/opt/cargolink/app/cargolink-app/pages/forwarder/clients/[id].vue?macro=true";
import { default as indexlLGqecCr5WZjTNtDr2fuzL2gzmCbzU3ODzlqrPseRAMMeta } from "/opt/cargolink/app/cargolink-app/pages/mover/cityxpress/index.vue?macro=true";
import { default as _91id_93gHvAYS0_jVPY8UkuysqqZVcJ8uG_B3H2sxQr4PtlzSUMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/intransit/[id].vue?macro=true";
import { default as index_45kR3cEnkD30kJGs89nlzh8KV9Aq2FWFHMv10jLiRRGwMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/messages/index.vue?macro=true";
import { default as index3JfGBwaZevH7jOdMJVieNxYFCC6_45sAIV6DlInX4SZqAMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/shipping/index.vue?macro=true";
import { default as _91uuid_93p9d5Wh6lE35uHV_45NgtvAea7uKFI0LkJYx7hcS9uxcMYMeta } from "/opt/cargolink/app/cargolink-app/pages/admin/warehouses/[uuid].vue?macro=true";
import { default as index9An5IwfwXyXHIendMZiAGpQx7RomeMdwYw1CIQu2ceUMeta } from "/opt/cargolink/app/cargolink-app/pages/carrier/analytics/index.vue?macro=true";
import { default as indexM0YA9N3FLbGqk9Ig4cSHoqwDIE_45OBfGvBF5ksKdjsJ8Meta } from "/opt/cargolink/app/cargolink-app/pages/carrier/shipments/index.vue?macro=true";
import { default as indexBo5nMGwdwsUvAJNAuXNrf4JMATgAwMogyBeGujVjavQMeta } from "/opt/cargolink/app/cargolink-app/pages/driver/cityxpress/index.vue?macro=true";
import { default as _91id_93iPqrnltE_l7rdoR9QPEZlbFPpOEh6Jg_gp09OJIr4fAMeta } from "/opt/cargolink/app/cargolink-app/pages/driver/cityxpress/offer/[id].vue?macro=true";
import { default as offerQkALT0zsmCKE_4529h99Et_YhwxZLnAouml9kuD__45AwX8Meta } from "/opt/cargolink/app/cargolink-app/pages/driver/cityxpress/offer.vue?macro=true";
import { default as indexAKkqperZw8LbTxBnlmaMpkIFj3lOzkPCmmFe8vLjNYUMeta } from "/opt/cargolink/app/cargolink-app/pages/forwarder/clients/index.vue?macro=true";
import { default as newIFzLwME0JlI44PkaKm_451_45T_sq_45_45__qdbjvCMC9rRwA0Meta } from "/opt/cargolink/app/cargolink-app/pages/forwarder/shipments/new.vue?macro=true";
import { default as indexTnu_zHCFbTrqPjHurFFUvjxpDVUMDdbZZfdvXZHIpeIMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/analytics/index.vue?macro=true";
import { default as indexb45r0KDUWOY0NYfi1VFy9DKCwy9P8aYj0afbc6dxQVoMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/documents/index.vue?macro=true";
import { default as indexips2tbY_P2FSyzu6ELP2QYqpCN49K1mE18JnESsJpdYMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/intransit/index.vue?macro=true";
import { default as indexB_vQ14nmoYM_45_45S0sROYTF0agQPe68KlisjIThjgepkEMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/templates/index.vue?macro=true";
import { default as index_haNA3D9N_tzXr4kToDWh_452bwJVk8nDFIuWhyY6XX4oMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/warehouse/index.vue?macro=true";
import { default as indexKiCxaAdA6cuOOJB8RDQSCXoSagOMtwuvW_bCB3Y_bpIMeta } from "/opt/cargolink/app/cargolink-app/pages/forwarder/requests/index.vue?macro=true";
import { default as indexsOUW5zUdTmp_455XkWa2W1_bBTXZpU4b4lc97RLBCGGqsMeta } from "/opt/cargolink/app/cargolink-app/pages/forwarder/settings/index.vue?macro=true";
import { default as index2GmJrOUnql9UggA8Jx6MiJ5tdcLOW_xvCu2mKeKlaysMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/cityxpress/index.vue?macro=true";
import { default as bookcgoG6I4irSCWxGo1QcgKKaqLOpP_qLGwacwtjEbwPt4Meta } from "/opt/cargolink/app/cargolink-app/pages/shipper/warehouse/[uuid]/book.vue?macro=true";
import { default as _91uuid_93nLju8QyAH1rNlYihMZX6Jm8M6Ia00HUgVxnTkjXcPRQMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/warehouse/[uuid].vue?macro=true";
import { default as indexERxbAvJya7dqPIMFda6Zvr_zJIfdCnnRRXrRe3IwYfcMeta } from "/opt/cargolink/app/cargolink-app/pages/warehouse-operator/index.vue?macro=true";
import { default as indexeMAM_vphQlzst8VMInu1ED5gk2PIOx064x70uZLdlPwMeta } from "/opt/cargolink/app/cargolink-app/pages/admin/notifications/index.vue?macro=true";
import { default as documentsbeY00ZF3GKmV53SKuPghHHVv4uXclarug4hYuCGgjkMMeta } from "/opt/cargolink/app/cargolink-app/pages/driver/settings/documents.vue?macro=true";
import { default as indexjpdUfPbKEjDzhHcXp9W_45UvVCsw2FTrkxEw6ybc2_45aBoMeta } from "/opt/cargolink/app/cargolink-app/pages/forwarder/shipments/index.vue?macro=true";
import { default as preferencesu8r492atv8bS_45YNGdDqVoCPhZlyn2pbkFc_45vQ8TI_FgMeta } from "/opt/cargolink/app/cargolink-app/pages/notifications/preferences.vue?macro=true";
import { default as indexEy1UGi8c34dddXuujSJdq0S6nDkmlYQEysXRpAKUtfQMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/address-book/index.vue?macro=true";
import { default as _91id_93cT0_459CW6Px7bbwOnnbFNDv8PWxCTSYM69H5HRTi5nj8Meta } from "/opt/cargolink/app/cargolink-app/pages/shipper/shipping/bids/[id].vue?macro=true";
import { default as supportXjcJbprsOKV_4oQSh6TxGeQ03SaC6TrT_45vx0_kUtO70Meta } from "/opt/cargolink/app/cargolink-app/pages/warehouse-operator/support.vue?macro=true";
import { default as indexBFJLqn_UMhuQs9lOaeor3XFPDmXCVZEaRSxnVNdECTwMeta } from "/opt/cargolink/app/cargolink-app/pages/admin/document-review/index.vue?macro=true";
import { default as indexj5zlWqVZ3_mRXEuEUnheUpNcE5hWfJxZqEnlP07n6gsMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/shipping/bids/index.vue?macro=true";
import { default as calendarWTGfMjR4fpmUNvRo7pO2LvIQSxgAC7IkrdvQNW5PvOkMeta } from "/opt/cargolink/app/cargolink-app/pages/warehouse-operator/calendar.vue?macro=true";
import { default as inventoryiG5Y5IgHwLn6MqkEyJcDFUDDZ16Lgl4ulnu5O4VPNsYMeta } from "/opt/cargolink/app/cargolink-app/pages/warehouse-operator/inventory.vue?macro=true";
import { default as newrtki8aQ2oXYogvcWbt1XsdjHUCGAECTkonAdVXrpfkoMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/cityxpress/movers/new.vue?macro=true";
import { default as indexj4J9EeaqDic69tkUk5zguCJxwMgN8vCuHzAefsXiXtAMeta } from "/opt/cargolink/app/cargolink-app/pages/admin/account-management/index.vue?macro=true";
import { default as indexKjbzJyL5ZdWSO4qKw0g1_JghWtz3r9KwbVJTlj_O3wkMeta } from "/opt/cargolink/app/cargolink-app/pages/driver/cityxpress/movers/index.vue?macro=true";
import { default as _91id_93G16u1421A1RumHZb2NrXwJs8tsPtccane58EoG3_XtQMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/cityxpress/movers/[id].vue?macro=true";
import { default as _91id_93Mn_thZXEaxhia8fsBpSaI3_EzIBgflyFY4Svp0LZpj8Meta } from "/opt/cargolink/app/cargolink-app/pages/admin/warehouses/operators/[id].vue?macro=true";
import { default as indexx_45OGutF4keurk9aQjZd077_45YuTGhE28dG1BY1OhP2FgMeta } from "/opt/cargolink/app/cargolink-app/pages/admin/warehouses/operators/index.vue?macro=true";
import { default as index1JmSVyyLutZECpT8LaBwGOKAKvpD4EeF1E7GQTNcaEgMeta } from "/opt/cargolink/app/cargolink-app/pages/carrier/forwarder-requests/index.vue?macro=true";
import { default as indexSIXxM4jzI4zho8Qoeo8N1YBO85q75uDLQGCa618B2HEMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/warehouse/bookings/index.vue?macro=true";
import { default as contract3MRw95ZT6RBtZEbxt3h_45ROv5W_45pFQPucB3Cv6XbrfP8Meta } from "/opt/cargolink/app/cargolink-app/pages/shipper/warehouse/bookings/[uuid]/contract.vue?macro=true";
import { default as inventorykTDhf8DAB6fDaAI0TZZIlFQJL5DkqLl1CbKkjY8NiAIMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/warehouse/bookings/[uuid]/inventory.vue?macro=true";
import { default as access_45passesCRUVHCgplt_45Xc9CPa8OWbKAK2wMzPAtcMJXPFHvTxzUMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/warehouse/bookings/[uuid]/access-passes.vue?macro=true";
import { default as _91uuid_93v9_45IRvMEEtmUdxerzxA_45MiO39VOKB80fuagzEzYKfjAMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/warehouse/bookings/[uuid].vue?macro=true";
import { default as indexM8ZKTc4RYySaL4mBRsx7Kg_e4L_45iDR8m0rHktec8n9EMeta } from "/opt/cargolink/app/cargolink-app/pages/warehouse-operator/bookings/index.vue?macro=true";
import { default as indexdX4zIg1LI44IDzKWJRCIPy54W6ZDZ_pe0gD1JbqYjtYMeta } from "/opt/cargolink/app/cargolink-app/pages/warehouse-operator/settings/index.vue?macro=true";
import { default as newIx_JWNt_45qI865ZgZzNumD_45Ivh0tqwi7dcGSWAwFBl5AMeta } from "/opt/cargolink/app/cargolink-app/pages/warehouse-operator/warehouses/new.vue?macro=true";
import { default as _91id_93dqHNFCiiNW6cl8w2wyKJd3PonRsJTFwThWERRcaR5NoMeta } from "/opt/cargolink/app/cargolink-app/pages/shipper/cityxpress/deliveries/[id].vue?macro=true";
import { default as indexAbRenCUmU0lkWFCvZbU0u5BeRh4gGp7K1fctsQ4UNhkMeta } from "/opt/cargolink/app/cargolink-app/pages/warehouse-operator/analytics/index.vue?macro=true";
import { default as _91uuid_93q2_HZq98j4065x_S8go6u7eMkl45kPOm0IAj5kIVjx8Meta } from "/opt/cargolink/app/cargolink-app/pages/warehouse-operator/bookings/[uuid].vue?macro=true";
import { default as indexOgmFL7_456wGwnKionOuZ9bwYP8avVPlKpHoeqUuf3ussMeta } from "/opt/cargolink/app/cargolink-app/pages/warehouse-operator/financials/index.vue?macro=true";
import { default as indexvgy0qHTf7apB124rlZgemPVB6t3p0JpRC5G1j6_452OdQMeta } from "/opt/cargolink/app/cargolink-app/pages/warehouse-operator/warehouses/index.vue?macro=true";
import { default as index3WPs8Q58Gr9XeVG5dpUWaLExgIwyNq8H6923Fz_45fJL8Meta } from "/opt/cargolink/app/cargolink-app/pages/warehouse-operator/warehouses/[uuid]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"middleware":"auth"},
    component: () => import("/opt/cargolink/app/cargolink-app/pages/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/opt/cargolink/app/cargolink-app/pages/terms.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/opt/cargolink/app/cargolink-app/pages/privacy.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: { ...(loginFshIbLiG6FKvO5F_45UPAwJ91b0hlwBW_45cVA_H8976DwYMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/auth/login.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexL5_45eQV0QAhQnNFpsxUJxCiRHEwwhhMjBpJs36jPFwxoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/admin/index.vue")
  },
  {
    name: "mover",
    path: "/mover",
    meta: { ...(indexynYCVMw6_DOneTi0gecbbPdUUejxrydfetVL3c0KohEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/mover/index.vue")
  },
  {
    name: "driver",
    path: "/driver",
    meta: { ...(indexpuOiu1ISDkI_5gqT29x_45IYWxMabWb1gkyNwOLuDQOagMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/driver/index.vue")
  },
  {
    name: "unauthorized",
    path: "/unauthorized",
    component: () => import("/opt/cargolink/app/cargolink-app/pages/unauthorized.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: { ...(registerR4HzjFq5D3_kQ5io6_45pIbPZqxWyDTyZTMrc_DGQFA0UMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/auth/register.vue")
  },
  {
    name: "carrier",
    path: "/carrier",
    meta: { ...(indexzFvJ6HZuw4NM_45MsvqLTva9AHLG_e7Lf6tnGI0Sg_45WpUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/carrier/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: { ...(indexT6aRCxMrOg22ui0UZCVZC7ZI1iOkbJGoa6DzEDSyMawMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/profile/index.vue")
  },
  {
    name: "shipper",
    path: "/shipper",
    meta: { ...(indexPIjYSIHingn2nQ5_45ufojslV8o1iMHnwawhh60ZETbnwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/index.vue")
  },
  {
    name: "driver-support",
    path: "/driver/support",
    meta: { ...(supportAfc57tOm2EkQATDYW9xlyQW_GbGQqTTRetHA1kqCIl8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/driver/support.vue")
  },
  {
    name: "driver-vehicle",
    path: "/driver/vehicle",
    meta: { ...(vehicleoAk6GvcW7nvh76ysiV99XgBaixGNHO9xLPMHbJJ9Up4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/driver/vehicle.vue")
  },
  {
    name: "admin-sms",
    path: "/admin/sms",
    meta: { ...(index_CfDggHdel3LdXNCWbOa7_454baeMa_ZQ__gjoTyF9Y14Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/admin/sms/index.vue")
  },
  {
    name: "driver-payments",
    path: "/driver/payments",
    meta: { ...(paymentsDEdrkzwqlv2EjcrWocWY7hyjglHLPbKk1pfD7fup7LEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/driver/payments.vue")
  },
  {
    name: "forwarder",
    path: "/forwarder",
    meta: { ...(indexzgEhSoaL91MTYQpeGsoZ1kfk4_45eSAGivKiLCjCh8Mr0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/forwarder/index.vue")
  },
  {
    name: "shipper-billing",
    path: "/shipper/billing",
    meta: { ...(billingJTHKHuLF4ifB_45VgP44G_45jfav3ysJUh6CFBccyN5msK8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/billing.vue")
  },
  {
    name: "shipper-support",
    path: "/shipper/support",
    meta: { ...(supporthwgsOm9WmkNvshIcb8L_Jiy7El4u78m9aWzA4dT_uDMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/support.vue"),
    children: [
  {
    name: "shipper-support-tickets-id",
    path: "tickets/:id()",
    meta: { ...(_91id_93GsypUA5UycWCvpm4LMgo7haJ76VMYdrASsi7tcsgmeMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/support/tickets/[id].vue")
  },
  {
    name: "shipper-support-disputes-id",
    path: "disputes/:id()",
    meta: { ...(_91id_932YlBzBbWbo5e7_a_4512euMdBXIomtFhW09ddW_IZdt78Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/support/disputes/[id].vue")
  },
  {
    name: "shipper-support-tickets",
    path: "tickets",
    meta: { ...(index7_45EuReQGdO4szTjbBMy6vIqoOZCNw2vEj7dHkPDwojQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/support/tickets/index.vue")
  },
  {
    name: "shipper-support-disputes",
    path: "disputes",
    meta: { ...(indexmqgg4QoCeUzivnAxUwvFcM1mCvBMYj0zdye00Hlt_28Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/support/disputes/index.vue")
  }
]
  },
  {
    name: "auth-mover-apply",
    path: "/auth/mover/apply",
    meta: { ...(applyYJI8ivCWyatwPgnAnq4ndj_455pB4Ukon8Z_An8Yr4cx0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/auth/mover/apply.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: { ...(indexDAe3ryfasNvbZSBjQtX_45yl4qpzOVcOmIe_454hyuGPuxYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/admin/users/index.vue")
  },
  {
    name: "auth-driver-apply",
    path: "/auth/driver/apply",
    meta: { ...(applyKGkMkPq8u4MTGt0BBTjugYNuL6zVrc3gLqoXoiNO2VYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/auth/driver/apply.vue")
  },
  {
    name: "auth-verify",
    path: "/auth/verify",
    meta: { ...(indexKHJa7zGeHfMmc_45l_LDDaEkaDLCUg1LGkVzFXSZEWZxgMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/auth/verify/index.vue")
  },
  {
    name: "account-restricted",
    path: "/account-restricted",
    meta: account_45restrictedhx6DRqS_S6oETl54MFonB7Cs4XVldfhDRo0IUphh_45lcMeta || {},
    component: () => import("/opt/cargolink/app/cargolink-app/pages/account-restricted.vue")
  },
  {
    name: "auth-carrier-apply",
    path: "/auth/carrier/apply",
    meta: { ...(apply7iM7wlGJp_f_45ANGdlSe2HvlndA_453S3e1JBENSdFfxmYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/auth/carrier/apply.vue")
  },
  {
    name: "auth-register copy",
    path: "/auth/register%20copy",
    meta: { ...(register_32copyj7DEyQYtiZ5fB9MXmsiW5hPOLkpvBVCOM50TlPmGCMcMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/auth/register copy.vue")
  },
  {
    name: "mover-offers",
    path: "/mover/offers",
    meta: { ...(indexUfRGJlRu0fOBV8RocEB5wdoMg_45pJSRTKuC3TdAypr44Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/mover/offers/index.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    meta: { ...(reset_45passwordo0d6XKNuheG33TWhhqxJARTDTct2MHKgFPElx70YTdwMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-verify-token",
    path: "/auth/verify/:token()",
    meta: { ...(_91token_93mvwtojPa1CU1JXb1mi4QbKOflHzM7B8P_45USEt4uOYz4Meta || {}), ...{"middleware":["guest"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/auth/verify/[token].vue")
  },
  {
    name: "mover-history",
    path: "/mover/history",
    meta: { ...(indexiOfJaL1psTlxWrz__45yFVDqtKDgHTDB3wHxkdVIoFrZIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/mover/history/index.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: indexNVLJr8Yfps4rAeV_kpz_0X2s8hoabLdHBLZy_iRmDSYMeta || {},
    component: () => import("/opt/cargolink/app/cargolink-app/pages/notifications/index.vue")
  },
  {
    name: "profile-preferences",
    path: "/profile/preferences",
    meta: { ...(preferencesE9Y_cI0Q6gmRsGIQDrObjaLGjc4X9D2oV1Mm5qK3nNYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/profile/preferences.vue")
  },
  {
    name: "admin-disputes",
    path: "/admin/disputes",
    meta: { ...(indexPPf2uFVWjgZPF1tvP9ioKCU2fudLyq9DQQu5bsHBJ2sMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/admin/disputes/index.vue")
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    meta: { ...(indexpoxD9kiaYragJYp42CWiM6NHZoLagpp8Am9f_Cmbp7gMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/admin/settings/index.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: { ...(forgot_45passwordXeuVjnBdnRwQSI7LCZ8E8gQ8dWzToqmj3hJz5a8gXxgMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-forwarder-apply",
    path: "/auth/forwarder/apply",
    meta: { ...(applySOAEUm7mGI5NYjn1XLOtuJWlYoNPUTJPdCL3LIMqbPYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/auth/forwarder/apply.vue")
  },
  {
    name: "mover-settings",
    path: "/mover/settings",
    meta: { ...(indexfprc1gHfkfifzoMa_S8ZPt53w10L70oq9bT3CYscuoEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/mover/settings/index.vue")
  },
  {
    name: "shipper-shipping-new",
    path: "/shipper/shipping/new",
    meta: { ...(newA9PgBS9G1XsnfPLR4q5LjeXlG4VD9_8AJieMXeCB_45PsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/shipping/new.vue")
  },
  {
    name: "admin-analytics",
    path: "/admin/analytics",
    meta: { ...(index9REPo3k3v_45VB4tqkzKX3rmVe8Pyb2OM9ntwfvyHZMroMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/admin/analytics/index.vue")
  },
  {
    name: "admin-shipments",
    path: "/admin/shipments",
    meta: { ...(indexm8YN0WzBcdRqgXLyZzPc_MqTNfDSUXgtmqWAGtNd6PUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/admin/shipments/index.vue")
  },
  {
    name: "carrier-drivers",
    path: "/carrier/drivers",
    meta: { ...(indexzgdieaLAZITXq2WpgSt6FMtbjteeOatXdpR99JCdGdEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/carrier/drivers/index.vue")
  },
  {
    name: "carrier-finance",
    path: "/carrier/finance",
    meta: { ...(indextCwtOkA_UpI6VfpeiSzUyfYamd9EUjCUqWNf_45rE8HyUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/carrier/finance/index.vue")
  },
  {
    name: "driver-intransit-id",
    path: "/driver/intransit/:id()",
    meta: { ...(_91id_936pGRyEWOxiNecVyYbjSb89NHfsK7G8vvNMKDcAGkHQUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/driver/intransit/[id].vue")
  },
  {
    name: "driver-settings",
    path: "/driver/settings",
    meta: { ...(indexjX3DFcTj6r0a3YnQzS_ryaHVXxdxRNPs29Sj5LMPDk0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/driver/settings/index.vue")
  },
  {
    name: "shipper-intransit-new",
    path: "/shipper/intransit/new",
    meta: { ...(newMlv0xuUJ1wocrfAl0un30OMbFkBEfsySzwYL3pep7N0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/intransit/new.vue")
  },
  {
    name: "shipper-messages-id",
    path: "/shipper/messages/:id()",
    meta: { ...(_91id_93Aq_ch2M1M_k45wX6R3yJRZvtdoW64kIfk_9mErhoMFcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/messages/[id].vue")
  },
  {
    name: "shipper-shipping-id",
    path: "/shipper/shipping/:id()",
    meta: { ...(_91id_93zz1_455rlPfz9NC4I_29tkdiGM0gwF5yFU19rlAYYlqSIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/shipping/[id].vue")
  },
  {
    name: "admin-financials",
    path: "/admin/financials",
    meta: { ...(indexvcTBy5s1BzAHNTlcT_458uS93UCdLa7KQgvCwThWsVmjMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/admin/financials/index.vue")
  },
  {
    name: "admin-warehouses",
    path: "/admin/warehouses",
    meta: indexV7b56L9QuyujzReFy_p50k3C0OWAZivBbf_R4yRY9gIMeta || {},
    component: () => import("/opt/cargolink/app/cargolink-app/pages/admin/warehouses/index.vue")
  },
  {
    name: "carrier-settings",
    path: "/carrier/settings",
    meta: { ...(indexnBZke5gklti3JS2aaDTmKw3AY4oJL61SY5en5fpcNWEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/carrier/settings/index.vue")
  },
  {
    name: "carrier-vehicles",
    path: "/carrier/vehicles",
    meta: { ...(indexHXsKXYmcKSVaf5NOFEqf6AWWvyfiI3fuCse2bUKzAtgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/carrier/vehicles/index.vue")
  },
  {
    name: "driver-cityxpress-trip",
    path: "/driver/cityxpress/trip",
    meta: { ...(tripaWRKH_45L7GWClgnoR9mrLD2uZxMH_45X5liZyZKEXwKr0QMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/driver/cityxpress/trip.vue"),
    children: [
  {
    name: "driver-cityxpress-trip-id",
    path: ":id()",
    meta: { ...(_91id_935TtB3Xo_454j6KoRNa9fkrqMGdqaTZ6NZfSP_45itwjhE6MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/driver/cityxpress/trip/[id].vue")
  }
]
  },
  {
    name: "driver-intransit",
    path: "/driver/intransit",
    meta: { ...(indexpAh9p3IQdKFI5HGizEWvWt3dsL1CNYGWvVzmjLjay78Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/driver/intransit/index.vue")
  },
  {
    name: "driver-shipments",
    path: "/driver/shipments",
    meta: { ...(indexv8BdqrZLh3fytWD0do5SFdw3VyPle81MTVRgkpDTN1MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/driver/shipments/index.vue")
  },
  {
    name: "forwarder-clients-id",
    path: "/forwarder/clients/:id()",
    meta: { ...(_91id_93ukg7XKkX9Ydw3s0Qf2IPwPR5qFfOqMSGL7Z7ZOvK_45qgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/forwarder/clients/[id].vue")
  },
  {
    name: "mover-cityxpress",
    path: "/mover/cityxpress",
    meta: { ...(indexlLGqecCr5WZjTNtDr2fuzL2gzmCbzU3ODzlqrPseRAMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/mover/cityxpress/index.vue")
  },
  {
    name: "shipper-intransit-id",
    path: "/shipper/intransit/:id()",
    meta: { ...(_91id_93gHvAYS0_jVPY8UkuysqqZVcJ8uG_B3H2sxQr4PtlzSUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/intransit/[id].vue")
  },
  {
    name: "shipper-messages",
    path: "/shipper/messages",
    meta: { ...(index_45kR3cEnkD30kJGs89nlzh8KV9Aq2FWFHMv10jLiRRGwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/messages/index.vue")
  },
  {
    name: "shipper-shipping",
    path: "/shipper/shipping",
    meta: { ...(index3JfGBwaZevH7jOdMJVieNxYFCC6_45sAIV6DlInX4SZqAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/shipping/index.vue")
  },
  {
    name: "admin-warehouses-uuid",
    path: "/admin/warehouses/:uuid()",
    meta: _91uuid_93p9d5Wh6lE35uHV_45NgtvAea7uKFI0LkJYx7hcS9uxcMYMeta || {},
    component: () => import("/opt/cargolink/app/cargolink-app/pages/admin/warehouses/[uuid].vue")
  },
  {
    name: "carrier-analytics",
    path: "/carrier/analytics",
    meta: { ...(index9An5IwfwXyXHIendMZiAGpQx7RomeMdwYw1CIQu2ceUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/carrier/analytics/index.vue")
  },
  {
    name: "carrier-shipments",
    path: "/carrier/shipments",
    meta: { ...(indexM0YA9N3FLbGqk9Ig4cSHoqwDIE_45OBfGvBF5ksKdjsJ8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/carrier/shipments/index.vue")
  },
  {
    name: "driver-cityxpress",
    path: "/driver/cityxpress",
    meta: { ...(indexBo5nMGwdwsUvAJNAuXNrf4JMATgAwMogyBeGujVjavQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/driver/cityxpress/index.vue")
  },
  {
    name: "driver-cityxpress-offer",
    path: "/driver/cityxpress/offer",
    meta: { ...(offerQkALT0zsmCKE_4529h99Et_YhwxZLnAouml9kuD__45AwX8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/driver/cityxpress/offer.vue"),
    children: [
  {
    name: "driver-cityxpress-offer-id",
    path: ":id()",
    meta: { ...(_91id_93iPqrnltE_l7rdoR9QPEZlbFPpOEh6Jg_gp09OJIr4fAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/driver/cityxpress/offer/[id].vue")
  }
]
  },
  {
    name: "forwarder-clients",
    path: "/forwarder/clients",
    meta: { ...(indexAKkqperZw8LbTxBnlmaMpkIFj3lOzkPCmmFe8vLjNYUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/forwarder/clients/index.vue")
  },
  {
    name: "forwarder-shipments-new",
    path: "/forwarder/shipments/new",
    meta: { ...(newIFzLwME0JlI44PkaKm_451_45T_sq_45_45__qdbjvCMC9rRwA0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/forwarder/shipments/new.vue")
  },
  {
    name: "shipper-analytics",
    path: "/shipper/analytics",
    meta: { ...(indexTnu_zHCFbTrqPjHurFFUvjxpDVUMDdbZZfdvXZHIpeIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/analytics/index.vue")
  },
  {
    name: "shipper-documents",
    path: "/shipper/documents",
    meta: { ...(indexb45r0KDUWOY0NYfi1VFy9DKCwy9P8aYj0afbc6dxQVoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/documents/index.vue")
  },
  {
    name: "shipper-intransit",
    path: "/shipper/intransit",
    meta: { ...(indexips2tbY_P2FSyzu6ELP2QYqpCN49K1mE18JnESsJpdYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/intransit/index.vue")
  },
  {
    name: "shipper-templates",
    path: "/shipper/templates",
    meta: { ...(indexB_vQ14nmoYM_45_45S0sROYTF0agQPe68KlisjIThjgepkEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/templates/index.vue")
  },
  {
    name: "shipper-warehouse",
    path: "/shipper/warehouse",
    meta: index_haNA3D9N_tzXr4kToDWh_452bwJVk8nDFIuWhyY6XX4oMeta || {},
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/warehouse/index.vue")
  },
  {
    name: "forwarder-requests",
    path: "/forwarder/requests",
    meta: { ...(indexKiCxaAdA6cuOOJB8RDQSCXoSagOMtwuvW_bCB3Y_bpIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/forwarder/requests/index.vue")
  },
  {
    name: "forwarder-settings",
    path: "/forwarder/settings",
    meta: { ...(indexsOUW5zUdTmp_455XkWa2W1_bBTXZpU4b4lc97RLBCGGqsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/forwarder/settings/index.vue")
  },
  {
    name: "shipper-cityxpress",
    path: "/shipper/cityxpress",
    meta: { ...(index2GmJrOUnql9UggA8Jx6MiJ5tdcLOW_xvCu2mKeKlaysMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/cityxpress/index.vue")
  },
  {
    name: "shipper-warehouse-uuid",
    path: "/shipper/warehouse/:uuid()",
    meta: _91uuid_93nLju8QyAH1rNlYihMZX6Jm8M6Ia00HUgVxnTkjXcPRQMeta || {},
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/warehouse/[uuid].vue"),
    children: [
  {
    name: "shipper-warehouse-uuid-book",
    path: "book",
    meta: bookcgoG6I4irSCWxGo1QcgKKaqLOpP_qLGwacwtjEbwPt4Meta || {},
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/warehouse/[uuid]/book.vue")
  }
]
  },
  {
    name: "warehouse-operator",
    path: "/warehouse-operator",
    meta: { ...(indexERxbAvJya7dqPIMFda6Zvr_zJIfdCnnRRXrRe3IwYfcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/warehouse-operator/index.vue")
  },
  {
    name: "admin-notifications",
    path: "/admin/notifications",
    meta: { ...(indexeMAM_vphQlzst8VMInu1ED5gk2PIOx064x70uZLdlPwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/admin/notifications/index.vue")
  },
  {
    name: "driver-settings-documents",
    path: "/driver/settings/documents",
    meta: { ...(documentsbeY00ZF3GKmV53SKuPghHHVv4uXclarug4hYuCGgjkMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/driver/settings/documents.vue")
  },
  {
    name: "forwarder-shipments",
    path: "/forwarder/shipments",
    meta: { ...(indexjpdUfPbKEjDzhHcXp9W_45UvVCsw2FTrkxEw6ybc2_45aBoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/forwarder/shipments/index.vue")
  },
  {
    name: "notifications-preferences",
    path: "/notifications/preferences",
    meta: preferencesu8r492atv8bS_45YNGdDqVoCPhZlyn2pbkFc_45vQ8TI_FgMeta || {},
    component: () => import("/opt/cargolink/app/cargolink-app/pages/notifications/preferences.vue")
  },
  {
    name: "shipper-address-book",
    path: "/shipper/address-book",
    meta: { ...(indexEy1UGi8c34dddXuujSJdq0S6nDkmlYQEysXRpAKUtfQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/address-book/index.vue")
  },
  {
    name: "shipper-shipping-bids-id",
    path: "/shipper/shipping/bids/:id()",
    meta: { ...(_91id_93cT0_459CW6Px7bbwOnnbFNDv8PWxCTSYM69H5HRTi5nj8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/shipping/bids/[id].vue")
  },
  {
    name: "warehouse-operator-support",
    path: "/warehouse-operator/support",
    meta: { ...(supportXjcJbprsOKV_4oQSh6TxGeQ03SaC6TrT_45vx0_kUtO70Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/warehouse-operator/support.vue")
  },
  {
    name: "admin-document-review",
    path: "/admin/document-review",
    meta: indexBFJLqn_UMhuQs9lOaeor3XFPDmXCVZEaRSxnVNdECTwMeta || {},
    component: () => import("/opt/cargolink/app/cargolink-app/pages/admin/document-review/index.vue")
  },
  {
    name: "shipper-shipping-bids",
    path: "/shipper/shipping/bids",
    meta: { ...(indexj5zlWqVZ3_mRXEuEUnheUpNcE5hWfJxZqEnlP07n6gsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/shipping/bids/index.vue")
  },
  {
    name: "warehouse-operator-calendar",
    path: "/warehouse-operator/calendar",
    meta: { ...(calendarWTGfMjR4fpmUNvRo7pO2LvIQSxgAC7IkrdvQNW5PvOkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/warehouse-operator/calendar.vue")
  },
  {
    name: "warehouse-operator-inventory",
    path: "/warehouse-operator/inventory",
    meta: { ...(inventoryiG5Y5IgHwLn6MqkEyJcDFUDDZ16Lgl4ulnu5O4VPNsYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/warehouse-operator/inventory.vue")
  },
  {
    name: "shipper-cityxpress-movers-new",
    path: "/shipper/cityxpress/movers/new",
    meta: { ...(newrtki8aQ2oXYogvcWbt1XsdjHUCGAECTkonAdVXrpfkoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/cityxpress/movers/new.vue")
  },
  {
    name: "admin-account-management",
    path: "/admin/account-management",
    meta: indexj4J9EeaqDic69tkUk5zguCJxwMgN8vCuHzAefsXiXtAMeta || {},
    component: () => import("/opt/cargolink/app/cargolink-app/pages/admin/account-management/index.vue")
  },
  {
    name: "driver-cityxpress-movers",
    path: "/driver/cityxpress/movers",
    meta: { ...(indexKjbzJyL5ZdWSO4qKw0g1_JghWtz3r9KwbVJTlj_O3wkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/driver/cityxpress/movers/index.vue")
  },
  {
    name: "shipper-cityxpress-movers-id",
    path: "/shipper/cityxpress/movers/:id()",
    meta: { ...(_91id_93G16u1421A1RumHZb2NrXwJs8tsPtccane58EoG3_XtQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/cityxpress/movers/[id].vue")
  },
  {
    name: "admin-warehouses-operators-id",
    path: "/admin/warehouses/operators/:id()",
    meta: _91id_93Mn_thZXEaxhia8fsBpSaI3_EzIBgflyFY4Svp0LZpj8Meta || {},
    component: () => import("/opt/cargolink/app/cargolink-app/pages/admin/warehouses/operators/[id].vue")
  },
  {
    name: "admin-warehouses-operators",
    path: "/admin/warehouses/operators",
    meta: indexx_45OGutF4keurk9aQjZd077_45YuTGhE28dG1BY1OhP2FgMeta || {},
    component: () => import("/opt/cargolink/app/cargolink-app/pages/admin/warehouses/operators/index.vue")
  },
  {
    name: "carrier-forwarder-requests",
    path: "/carrier/forwarder-requests",
    meta: { ...(index1JmSVyyLutZECpT8LaBwGOKAKvpD4EeF1E7GQTNcaEgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/carrier/forwarder-requests/index.vue")
  },
  {
    name: "shipper-warehouse-bookings",
    path: "/shipper/warehouse/bookings",
    meta: indexSIXxM4jzI4zho8Qoeo8N1YBO85q75uDLQGCa618B2HEMeta || {},
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/warehouse/bookings/index.vue")
  },
  {
    name: "shipper-warehouse-bookings-uuid",
    path: "/shipper/warehouse/bookings/:uuid()",
    meta: _91uuid_93v9_45IRvMEEtmUdxerzxA_45MiO39VOKB80fuagzEzYKfjAMeta || {},
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/warehouse/bookings/[uuid].vue"),
    children: [
  {
    name: "shipper-warehouse-bookings-uuid-contract",
    path: "contract",
    meta: contract3MRw95ZT6RBtZEbxt3h_45ROv5W_45pFQPucB3Cv6XbrfP8Meta || {},
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/warehouse/bookings/[uuid]/contract.vue")
  },
  {
    name: "shipper-warehouse-bookings-uuid-inventory",
    path: "inventory",
    meta: inventorykTDhf8DAB6fDaAI0TZZIlFQJL5DkqLl1CbKkjY8NiAIMeta || {},
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/warehouse/bookings/[uuid]/inventory.vue")
  },
  {
    name: "shipper-warehouse-bookings-uuid-access-passes",
    path: "access-passes",
    meta: access_45passesCRUVHCgplt_45Xc9CPa8OWbKAK2wMzPAtcMJXPFHvTxzUMeta || {},
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/warehouse/bookings/[uuid]/access-passes.vue")
  }
]
  },
  {
    name: "warehouse-operator-bookings",
    path: "/warehouse-operator/bookings",
    meta: { ...(indexM8ZKTc4RYySaL4mBRsx7Kg_e4L_45iDR8m0rHktec8n9EMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/warehouse-operator/bookings/index.vue")
  },
  {
    name: "warehouse-operator-settings",
    path: "/warehouse-operator/settings",
    meta: { ...(indexdX4zIg1LI44IDzKWJRCIPy54W6ZDZ_pe0gD1JbqYjtYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/warehouse-operator/settings/index.vue")
  },
  {
    name: "warehouse-operator-warehouses-new",
    path: "/warehouse-operator/warehouses/new",
    meta: { ...(newIx_JWNt_45qI865ZgZzNumD_45Ivh0tqwi7dcGSWAwFBl5AMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/warehouse-operator/warehouses/new.vue")
  },
  {
    name: "shipper-cityxpress-deliveries-id",
    path: "/shipper/cityxpress/deliveries/:id()",
    meta: { ...(_91id_93dqHNFCiiNW6cl8w2wyKJd3PonRsJTFwThWERRcaR5NoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/shipper/cityxpress/deliveries/[id].vue")
  },
  {
    name: "warehouse-operator-analytics",
    path: "/warehouse-operator/analytics",
    meta: { ...(indexAbRenCUmU0lkWFCvZbU0u5BeRh4gGp7K1fctsQ4UNhkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/warehouse-operator/analytics/index.vue")
  },
  {
    name: "warehouse-operator-bookings-uuid",
    path: "/warehouse-operator/bookings/:uuid()",
    meta: { ...(_91uuid_93q2_HZq98j4065x_S8go6u7eMkl45kPOm0IAj5kIVjx8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/warehouse-operator/bookings/[uuid].vue")
  },
  {
    name: "warehouse-operator-financials",
    path: "/warehouse-operator/financials",
    meta: { ...(indexOgmFL7_456wGwnKionOuZ9bwYP8avVPlKpHoeqUuf3ussMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/warehouse-operator/financials/index.vue")
  },
  {
    name: "warehouse-operator-warehouses",
    path: "/warehouse-operator/warehouses",
    meta: { ...(indexvgy0qHTf7apB124rlZgemPVB6t3p0JpRC5G1j6_452OdQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/warehouse-operator/warehouses/index.vue")
  },
  {
    name: "warehouse-operator-warehouses-uuid",
    path: "/warehouse-operator/warehouses/:uuid()",
    meta: { ...(index3WPs8Q58Gr9XeVG5dpUWaLExgIwyNq8H6923Fz_45fJL8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/cargolink/app/cargolink-app/pages/warehouse-operator/warehouses/[uuid]/index.vue")
  }
]